<button mat-icon-button color="primary" title="Return to the previous screen" class="print" (click)="back()">
    <mat-icon>keyboard_backspace</mat-icon> Back
</button>
<div class="header">
    <section-title [text]="'Transaction details'"></section-title>
    <span class="spacer"></span>
    <button mat-icon-button color="primary" title="Print transaction details" class="print" (click)="print()">
        <mat-icon>print</mat-icon>
    </button>
</div>
<mat-card>
    <mat-card-content>
        <span class="details">
            <div>Transaction ID: <span class="data">{{transaction?.transactionId}}</span></div>
            <div>Transaction Date: <span class="data">{{transaction?.transactionDate | localTime}}</span></div>
            <div>Payment Method: <span class="data">{{paymentMethodService.nameof(transaction?.paymentMethodId || 0)}}</span></div>
            <div *ngIf="transaction?.paymentRequestId">Payment Request: <span class="data">{{transaction?.paymentRequestId}}</span></div>
            <div>Wallet Name: <span class="data">{{transaction?.walletAddressName}}</span></div>
            <div>Wallet Identifier: <span class="data">{{transaction?.walletAddressIdentifier}}</span></div>
            <div *ngIf="transaction?.correspondingAddressIdentifier">Corresponding Wallet Identifier: <span class="data">{{transaction?.correspondingAddressIdentifier}}</span></div>
            <div *ngIf="transaction?.referenceId">Reference: <span class="data">{{transaction.referenceId}}</span></div>
            <div *ngIf="transaction?.originDomain">Origin Domain: <span class="data">{{transaction.originDomain}}</span></div>
        </span>
        <span class="spacer"></span>
        <span class="details">
            <div class="amount-header">Gross amount</div>
            <div class="amount">{{transaction?.unit}} {{transaction?.grossAmount | number:'1.0-2'}}</div>
            <div *ngIf="transaction?.chargedBack" class="warning">
                <mat-icon>warning</mat-icon> CHARGE BACK
            </div>
        </span>
    </mat-card-content>
</mat-card>
<div class="content top-space">
    <div left-panel>
        <section-title [text]="'Recipient'"></section-title>
        <mat-card>
            <mat-card-content>
                <span class="details">
                    <div>Name: <span class="data">{{transaction?.recipientName}}</span></div>
                    <div>Identifier: <span class="data">{{transaction?.recipientId}}</span></div>
                    <div>Net Amount: <span class="data">{{transaction?.unit}} {{transaction?.netAmount | number:'1.0-2'}}</span></div>
                </span>
            </mat-card-content>
        </mat-card>
    </div>
    <div right-panel>
        <section-title [text]="'Sender'"></section-title>
        <mat-card>
            <mat-card-content>
                <span class="details">
                    <div>Name: <span class="data">{{transaction?.senderName}}</span></div>
                    <div>Identifier: <span class="data">{{transaction?.senderId}}</span></div>
                    <div>Gross Amount: <span class="data">{{transaction?.unit}} {{transaction?.grossAmount | number:'1.0-2'}}</span></div>
                </span>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div class="content top-space">
    <div left-panel>
        <section-title [text]="'Payment Details'"></section-title>
        <mat-card>
            <mat-card-content>
                <div class="content">
                    <div left-panel>
                        <span class="details">
                            <div>Gross Amount: <span class="data">{{transaction?.unit}} {{transaction?.grossAmount | number:'1.0-2'}}</span></div>
                            <div>Fee Amount: <span class="data">{{transaction?.unit}} {{transaction?.feeAmount | number:'1.0-2'}}</span></div>
                            <div>Net Amount: <span class="data">{{transaction?.unit}} {{transaction?.netAmount | number:'1.0-2'}}</span></div>
                        </span>
                    </div>
                    <div right-panel>
                        <span class="details">
                            <div *ngIf="transaction?.convertedUnit && transaction?.convertedAmount">Converted Amount: <span class="data">{{transaction?.convertedUnit}} {{transaction?.convertedAmount | number:'1.0-2'}}</span></div>
                            <div>3DS: <span class="data">{{transaction?.threeDs ? 'Yes' : 'No'}}</span></div>
                            <div>Premium: <span class="data">{{transaction?.isPremiumCardBin ? 'Yes' : 'No'}}</span></div>
                        </span>
                    </div>
                </div>               
            </mat-card-content>
        </mat-card>
    </div>
    <div right-panel>
        <section-title [text]="'Refund Details'"></section-title>
        <mat-card>
            <mat-card-content>
                <span class="details">
                    <div>Refunded: <span class="data">{{transaction?.refunded ? 'Yes' : 'No'}}</span></div>
                    <div>Refund Date: <span class="data">{{transaction?.refundDate | localTime}}</span></div>
                    <div>Refund Type: <span class="data">{{refundTypeService.nameof(transaction?.refundTypeId || 0)}}</span></div>
                </span>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div *ngIf="transaction?.payerName" class="top-space">
    <section-title [text]="'Payer'"></section-title>
    <mat-card>
        <mat-card-content>
            <span class="details">
                <div>Name: <span class="data">{{transaction?.payerName}}</span></div>
                <div>Email: <span class="data">{{transaction?.payerEmail}}</span></div>
                <div>Country: <span class="data">{{transaction?.payerCountry}}</span></div>
                <div *ngIf="transaction?.paymentMethodId == paymentMethod.creditCard">Credit Card: <span class="data">{{transaction?.ccNumber}}</span></div>
            </span>
        </mat-card-content>
    </mat-card>
</div>
<div *ngIf="transaction?.notes" class="top-space">
    <section-title [text]="'Notes'"></section-title>
    <mat-card>
        <mat-card-content>
            <span class="details">
                <div>{{transaction?.notes}}</div>
            </span>
        </mat-card-content>
    </mat-card>
</div>
